import { compose } from "redux";

import withSecondaryBarSet from "app/pages/sales-intelligence/hoc/withSecondaryBarSet";
import CrmEnrichmentJobEditor from "app/pages/sales-intelligence/modules/crm-enrichment/impl/hubspot/containers/CrmEnrichmentJobEditor/CrmEnrichmentJobEditor";
import { withConnectionCheck } from "app/pages/sales-intelligence/pages/manage-integration/hocs/withConnectionCheck";
import withCrmEnrichmentProvider from "app/pages/sales-intelligence/pages/manage-integration/hocs/withCrmEnrichmentProvider";
import { withMappingsAndColumnsFetch } from "app/pages/sales-intelligence/pages/manage-integration/hocs/withMappingsAndColumnsFetch";

const HsEnrichmentJobEditContainer = compose(
    withCrmEnrichmentProvider,
    withConnectionCheck,
    withSecondaryBarSet("SalesIntelligenceManagement"),
    withMappingsAndColumnsFetch({ refetchIfExists: true }),
)(CrmEnrichmentJobEditor);

export default HsEnrichmentJobEditContainer;
